module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-SemiBold.8486eebf.woff2";